import React from 'react';
import { LockKeyhole } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { useI18n } from '../../hooks/useI18n';

export const FeatureDisabledPanel = ({ title, body, actionLabel, onAction }) => {
  const { t } = useI18n();

  return (
    <section className="rounded-xl border border-neutral-200 bg-white p-8 dark:border-neutral-800 dark:bg-neutral-950">
      <div className="flex min-h-[280px] flex-col items-center justify-center gap-4 text-center">
        <div className="inline-flex h-12 w-12 items-center justify-center rounded-xl border border-neutral-200 bg-neutral-50 text-neutral-500 dark:border-neutral-800 dark:bg-neutral-900">
          <LockKeyhole size={20} />
        </div>
        <div className="max-w-md space-y-2">
          <h2 className="text-base font-semibold text-neutral-950 dark:text-white">{title}</h2>
          <p className="text-sm leading-6 text-neutral-500">{body}</p>
        </div>
        {onAction ? (
          <Button type="button" variant="secondary" onClick={onAction}>
            {actionLabel || t('featuresSettings')}
          </Button>
        ) : null}
      </div>
    </section>
  );
};
